import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

export default function CalendarIndividualDates({ selectedDates = [], onSelectDates }) {
  const [currentMonth, setCurrentMonth] = useState(dayjs());
  const [selected, setSelected] = useState(new Set(selectedDates));

  const daysInMonth = currentMonth.daysInMonth();
  const startDay = currentMonth.startOf('month').day(); // Sunday = 0

  const toggleDate = (dateStr) => {
    const newSelected = new Set(selected);
    if (newSelected.has(dateStr)) {
      newSelected.delete(dateStr);
    } else {
      newSelected.add(dateStr);
    }
    setSelected(newSelected);
    onSelectDates([...newSelected].sort()); // Send back to parent
  };

  useEffect(() => {
    setSelected(new Set(selectedDates));
  }, [selectedDates]);

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <button onClick={() => setCurrentMonth(currentMonth.subtract(1, 'month'))}>←</button>
        <h2 className="font-semibold">{currentMonth.format('MMMM YYYY')}</h2>
        <button onClick={() => setCurrentMonth(currentMonth.add(1, 'month'))}>→</button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-center text-sm font-medium text-gray-600 mb-1">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d) => (
          <div key={d}>{d}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1 text-center">
        {[...Array(startDay)].map((_, i) => (
          <div key={`pad-${i}`} />
        ))}
        {[...Array(daysInMonth)].map((_, i) => {
          const date = currentMonth.date(i + 1);
          const dateStr = date.format('YYYY-MM-DD');
          const isSelected = selected.has(dateStr);

          return (
            <button
              key={dateStr}
              onClick={() => toggleDate(dateStr)}
              className={`p-2 rounded text-sm ${
                isSelected
                  ? 'bg-blue-600 text-white'
                  : 'hover:bg-blue-100 bg-gray-50 text-gray-800'
              }`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
}
